import React, { Component } from "react";
import {
  Wrapper,
  Icon,
  Button,
  Title,
  Row,
  Copy
} from "app/NativeComponents/common";

import { TemplatePreview } from "app/NativeComponents/snippets";

class TemplatePreviewWrapper extends Component {
  render() {
    return (
      <Row
        style={{
          alignItems: "center",
          justifyContent: "center",
          paddingTop: 5,
          paddingBottom: 5
        }}
      >
        <Wrapper
          style={{
            padding: 5
          }}
        >
          <TemplatePreview
            image={this.props.fields.template_preview}
            template_id={this.props.fields.template_id}
            token={this.props.token}
            save_info={true}
            width={150}
          />
        </Wrapper>
        <Wrapper
          style={{
            padding: 5
          }}
        >
          <TemplatePreview
            image={this.props.fields.template_preview_back}
            template_id={this.props.fields.template_id}
            side="back"
            token={this.props.token}
            save_info={true}
            width={150}
          />
        </Wrapper>
      </Row>
    );
  }
}

export default TemplatePreviewWrapper;
